
import {
  Vue, Component, Prop, PropSync,
} from 'vue-property-decorator';

@Component
export default class ChangesSaved extends Vue {
  @PropSync('show', { required: false, default: false }) showSynced!: boolean;

  @Prop({ required: false, default: true }) success!: boolean;

  mounted(): void {
    setTimeout(() => {
      this.showSynced = false;
    }, 2000);
  }
}
